import { connect } from 'react-redux';
import { getEnabledFlagsList } from '../selectors';
import { setFlags } from '../actions';
const mapStateToProps = (state)=>({
        flags: getEnabledFlagsList(state)
    });
const mapDispatchToProps = {
    setFlags
};
export default connect(mapStateToProps, mapDispatchToProps);
